import React from "react";
import { SimpleSection } from "./SimpleSection";
import "./CommonUIStyles/CommonUIStyles.css";
export const GroupSections = ({ data, styleObject, actions, searchMethod }) => {
  /**
   * expected data:
   * @param {array} data - array of object, each containing group header and rows data for sections
   * @param {object} styleObject - styleObject containing other style objects for different sections
   */

  return (
    <div>
      {data.map((groupData) => {
        return (
          <div key={groupData.header}>
            <div className="gr_s_h"> {groupData.header}</div>

            <input placeholder="Search..." className="gr_s_search" onChange={(e) => searchMethod(e.target.value)}></input>

            <div>
              {groupData.rows.map((row) => (
                <SimpleSection key={row.data && row.data.id} data={row.data} rows={row.rows} actions={actions} styleConfig={styleObject} />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/CommonUI/Sections/GroupSections.js